import React, { Component } from 'react';
import './styles.scss';

class FacilityRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedKey: '',
      isChecked: false,
    };
  }

  handleFacilityChange = (e) => {
    e.preventDefault();
    this.props.onFacilityChange({
      facilityName: e.target.value,
      facilityAddress: this.props.facilityAddress,
      facilityUCMId: this.props.ucmId,
    });
  };

  render() {
    const {
      facilityName = '',
      city = '',
      country = '',
      state = '',
      street = '',
      postalCode = '',
      isChecked = false,
    } = this.props;

    const key = this.props.ucmId;

    return (
      <div key={`${key}-div-wrapper`} className="radio-wrapper">
        <div key={`${key}-div-container`} className="radio-container">
          <label key={`${key}"-label"`} className="radio-and-label-container">
            <input
              key={key}
              type="radio"
              name="facility"
              className="radio-input"
              checked={isChecked}
              value={facilityName}
              onChange={this.handleFacilityChange.bind(this)}
            />
            <div className="label-text-container">
              <div className="label__facility-name">{facilityName}</div>
              <div className="label__facility-address">{street}</div>
              <div className="label__facility-address">{`${city}, ${state}, ${postalCode} ${country}`}</div>
            </div>
          </label>
        </div>
      </div>
    );
  }
}
export default FacilityRadio;
